class CheckboxGroupController extends window.StimulusController {
  static targets = ["hiddenInputGroup", "showMoreButton"];
  static values = { showMoreText: String, showLessText: String };

  static outlets = ["plp-filters"];

  toggleShowMore(e) {
    e.preventDefault();

    const isHidden = this.hiddenInputGroupTarget.classList.toggle("tw-hidden");

    this.showMoreButtonTarget.textContent = isHidden
      ? this.showMoreTextValue
      : this.showLessTextValue;
  }

  submit(e) {
    e.preventDefault();

    this.plpFiltersOutlet.submitForm();
  }
}

Stimulus.register("checkbox-group", CheckboxGroupController);
